import AppPageDataGrid from "./AppPageDataGrid";

import "./AppPageDataGrid.scss";

export { AppPageDataGrid };
